import Vue from 'vue';
import VueGtagPlugin from 'vue-gtag';
import App from './App.vue';
import router from './router';
import { store } from './store';
import './polyfills';
import DialogPlugin from './plugins/dialog';
import 'vue-tsx-support/enable-check';
import * as Locale from '@/plugins/i18n';
import * as PleasedApi from '@/common/api/api.pleased';
import '@/vendor/baguetteBox-js/baguetteBox.min.css';

Vue.config.productionTip = false;
Vue.use(DialogPlugin);
Vue.use(VueGtagPlugin, {
  bootstrap: false,
  appName: 'Pleased',
  pageTrackerScreenviewEnabled: true,
}, router);

window.VMPY = new Vue({
  router,
  store,
  render: h => h(App),
  i18n: Locale.i18n,
}).$mount('#app');

// this is for $dialog
window.h = window.VMPY.$createElement;

// Set header for pleased API when language changes.
Locale.addListener(({ current: acceptLanguage }) => PleasedApi.setConfig({ acceptLanguage }), true);
